exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-0889b7f5],.icon svg[data-v-0889b7f5],.panel__question[data-v-0889b7f5]{transition:.3s}.panel__answer p[data-v-0889b7f5]:last-of-type{margin-bottom:0}.panel__container.active .icon[data-v-0889b7f5]{transform:rotate(90deg)}", ""]);

// exports
